
const CaseStudySection = () => {
  return (
    <section className="py-20" style={{ backgroundColor: '#F8F4EF' }}>
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <h2 
          className="text-4xl lg:text-5xl font-bold mb-8"
          style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
        >
          Real Impact, Coming Soon
        </h2>
        
        <div className="space-y-6 mb-10">
          <p 
            className="text-xl leading-relaxed"
            style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}
          >
            We're currently onboarding our first round of partner organizations.
          </p>
          
          <p 
            className="text-xl leading-relaxed"
            style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}
          >
            As we complete each project, we'll share real before-and-after results, time saved, and improvements to how teams work day-to-day.
          </p>
          
          <p 
            className="text-xl leading-relaxed font-medium"
            style={{ color: '#7B6655', fontFamily: 'Inter, sans-serif' }}
          >
            If you'd like to be part of our first round of documented success stories, we'd love to connect.
          </p>
        </div>
        
        <button 
          onClick={() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' })}
          className="inline-flex items-center space-x-2 px-8 py-4 rounded-lg font-semibold text-white transition-all duration-200 whitespace-nowrap cursor-pointer hover:opacity-90"
          style={{ backgroundColor: '#7B6655', fontFamily: 'Manrope, Inter, sans-serif' }}
        >
          <span>Schedule a Workflow Audit</span>
          <i className="ri-arrow-right-line"></i>
        </button>
      </div>
    </section>
  );
};

export default CaseStudySection;
